import React, { useState } from "react";
import { Box, Stack, InputAdornment, IconButton } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import TextInput from "qubCommon/Inputs/TextInput";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { PASSWORD_REGEX } from "qubCommon/helperMethods/passwordPolicy";
import { changePassword } from "apis/controllers/users";
import { enqueueSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { logout } from "store/authReducer";
import { persistor } from "store/store";
// import { changePasswordApi } from "apis/controllers/users"; // όταν το φτιάξεις

const schema = yup.object({
    currentPassword: yup.string().required("Απαιτείται ο τρέχων κωδικός"),
    newPassword: yup
        .string()
        .matches(
            PASSWORD_REGEX,
            "Ο κωδικός πρέπει να έχει 8 χαρακτήρες, 1 πεζό, 1 κεφαλαίο, 1 αριθμό και 1 ειδικό σύμβολο"
        )
        .required("Απαιτείται νέος κωδικός"),
    confirmPassword: yup
        .string()
        .oneOf([yup.ref("newPassword")], "Οι κωδικοί δεν ταιριάζουν")
        .required("Απαιτείται επιβεβαίωση"),
});

const ChangePassword: React.FC = () => {
    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
        },
    });

    const { handleSubmit } = methods;

    const [showCurrent, setShowCurrent] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const onSubmit = async (data: any) => {
        if (loading) return;
        setLoading(true);
        try {
            console.log("Change password payload:", data);
            const res = await changePassword(data);
            if (res?.status === 'success') {
                enqueueSnackbar(res?.message || "Ο κωδικός άλλαξε με επιτυχία", { variant: "success" });
                methods.reset();
                dispatch(logout());
                persistor.purge();

            }
            else enqueueSnackbar(res?.message || "Παρουσιάστηκε σφάλμα κατά την αλλαγή κωδικού", { variant: res?.status || 'error' })
        } catch (err) {
            console.error(err);
            // enqueueSnackbar("Παρουσιάστηκε σφάλμα κατά την αλλαγή κωδικού", { variant: "error" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <FormProvider {...methods}>
            <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <Stack spacing={2}>
                    <TextInput
                        name="currentPassword"
                        label="Τρέχων Κωδικός"
                        isFullWidth
                        type={showCurrent ? "text" : "password"}
                        otherInputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowCurrent((v) => !v)}>
                                        {showCurrent ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextInput
                        name="newPassword"
                        label="Νέος Κωδικός"
                        isFullWidth
                        type={showNew ? "text" : "password"}
                        otherInputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowNew((v) => !v)}>
                                        {showNew ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextInput
                        name="confirmPassword"
                        label="Επιβεβαίωση Νέου Κωδικού"
                        isFullWidth
                        type={showConfirm ? "text" : "password"}
                        otherInputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowConfirm((v) => !v)}>
                                        {showConfirm ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <LoadingButton
                        loading={loading}
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ alignSelf: "flex-start", mt: 1 }}
                    >
                        Αλλαγή Κωδικού
                    </LoadingButton>
                </Stack>
            </Box>
        </FormProvider>
    );
};

export default ChangePassword;
